import { BankGuaranteeDetails } from './BankGuaranteeTable';
import Data from './Data/data.json'

export const data = Data;